import {
	SET_LOCALE,
	SET_STORE_ID,
	SET_ZIP_CODE,
	FETCH_LOCALIZATION_PENDING,
	FETCH_LOCALIZATION_SUCCESS,
	FETCH_LOCALIZATION_FAILURE,
	SET_WRITE_DIRECTION,
	LocalizationState,
	LocalizationStateTypes,
	SET_KOMPIS_TRANSLATIONS,
} from './types';

const initialState: LocalizationState = {
	locale: null,
	localization: null,
	translations: {},
	kompisTranslations: null,
	fetchLocalizationPending: false,
	writeDirection: 'ltr',
};

export function localizationReducer(
	state = initialState,
	action: LocalizationStateTypes
): LocalizationState {
	switch (action.type) {
		case SET_LOCALE:
			return { ...state, locale: action.value };
		case SET_STORE_ID:
			return { ...state, storeId: action.value };
		case SET_ZIP_CODE:
			return { ...state, zipCode: action.value };
		case SET_WRITE_DIRECTION:
			return { ...state, writeDirection: action.value };
		case FETCH_LOCALIZATION_PENDING: {
			return { ...state, fetchLocalizationPending: true };
		}
		case FETCH_LOCALIZATION_SUCCESS: {
			const { localization, translations } = action;
			return { ...state, localization, translations, fetchLocalizationPending: false };
		}
		case FETCH_LOCALIZATION_FAILURE: {
			return { ...state, fetchLocalizationPending: false };
		}
		case SET_KOMPIS_TRANSLATIONS: {
			return { ...state, kompisTranslations: action.kompisTranslations };
		}
		default:
			return state;
	}
}
